// extracted by mini-css-extract-plugin
export default {"coin":"coin_coin__W0BYu","input":"coin_input__ySMEg","amount":"coin_amount__yipX9"};